// extracted by mini-css-extract-plugin
export default {"container":"IRb5K","bottom":"YxhPN"};